<template>
    <div class="position-box">
        <div class="head index">
            <div class="text">{{syName}}</div>
            <div class="title">{{$t('footer.home')}}</div>
            <router-link tag="div" to="/language" class="lang">{{$t('index.language')}}</router-link>
        </div>
        <div class="cotainer">
            <div class="banner-wrap" v-show="bannerList.length > 0">
                <swiper class="banner-box swiper" ref="mySwiper" :options="swiperOption">
                    <swiper-slide class="banner" v-for="(item,index) in bannerList" :key="index"><img class="img" :src="item.url" alt="banner"></swiper-slide>
                    <div class="swiper-pagination"  slot="pagination"></div>
                </swiper>
            </div>
            <div class="notice-box" v-show="noticeList.length > 0" v-if="lang == 'ar'">
              <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
              <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
              <ul class="notice">
                  <swiper class="swiper" ref="mySwipers" :options="swiperOption2">
                      <swiper-slide class="text" v-for="(item,index) in noticeList" :key="index">{{item.title}}</swiper-slide>
                  </swiper>
              </ul>
              <img class="icon" v-if="theme" src="@/assets/theme/notice.png" alt="">
              <img class="icon" v-else src="@/assets/notify.png" alt="">
            </div>
            <div class="notice-box" v-show="noticeList.length > 0" v-else>
                <img class="icon" v-if="theme" src="@/assets/theme/notice.png" alt="">
                <img class="icon" v-else src="@/assets/notify.png" alt="">
                <ul class="notice">
                    <swiper class="swiper" ref="mySwipers" :options="swiperOption2">
                        <swiper-slide class="text" v-for="(item,index) in noticeList" :key="index">{{item.title}}</swiper-slide>
                    </swiper>
                </ul>
                <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
            </div>
            <ul class="item-box">
              <router-link class="item" tag="li" to="/currency">
                  <img class="icon" src="@/assets/index/icon-wydb.png" alt="">
                  <div class="text">{{$t('wydb.title')}}</div>
              </router-link>
              <router-link class="item" tag="li" to="/subscription">
                  <img class="icon" src="@/assets/index/icon-xbsg.png" alt="">
                  <div class="text">{{$t('xbsg.title')}}</div>
              </router-link>
              <router-link class="item" tag="li" to="/propagate">
                  <img class="icon" src="@/assets/index/px.png" alt="">
                  <div class="text">{{$t('bzhl.title')}}</div>
              </router-link>
              <router-link class="item" tag="li" to="/help">
                  <img class="icon" src="@/assets/index/icon-bzzx.png" alt="">
                  <div class="text">{{$t('my.hc')}}</div>
              </router-link>
            </ul>
            <ul class="coin-box">
                <li class="coin-li" v-for="(item, index) in listData" :key="index" @click="jump(item.symbol)">
                    <div class="coin-head">
                        <img class="icon" v-if="item.icon && item.type == 1" :src="item.icon" alt="">
                        <div class="text">{{item.name}}/<span class="t1">USDT</span></div>
                    </div>
                    <div class="price">{{item.new_price || 0.00 | toFixed4}}</div>
                    <div class="change" :class="{red: item.grow < 0}"><img v-if="item.grow < 0" class="arrow die" src="@/assets/arrow_icon_red.png" alt=""><img v-else class="arrow" src="@/assets/arrow_icon.png" alt="">{{item.grow || 0.00 }}%</div>
                </li>
            </ul>
            <div class="line"></div>
            <ul class="tab-box">
              <li class="tab" :class="{active: type == 2}" @click="tab(2)">{{$t('langNew.gjs')}}</li>
              <li class="tab" :class="{active: type == 3}" @click="tab(3)">{{$t('langNew.yy')}}</li>
              <li class="tab" :class="{active: type == 1}" @click="tab(1)">{{$t('langNew.szhb')}}</li>
            </ul>
            <ul class="table-head">
                <li class="th">{{$t('mk.name')}}</li>
                <li class="th text-center">{{$t('mk.newPrice')}}</li>
                <li class="th text-right">{{$t('mk.rank')}}</li>
            </ul>
            <ul class="table-body">
                <li class="tr" v-for="(item, index) in listData" :key="index" @click="jump(item.symbol)">
                    <div class="item coin">
                        <img class="icon" v-if="item.type == 1" :src="item.icon" alt="">
                        <div class="t1">{{item.name}}/<span class="t2">USDT</span></div>
                    </div>
                    <div class="item price text-center">{{item.new_price || 0.00 | toFixed4}}</div>
                    <div class="item change text-right"><span class="persent" :class="{'bg-red': item.grow < 0}">{{item.grow || 0.000 | toFixed2}}%</span></div>
                </li>
            </ul>
        </div>
        <!-- 下载弹窗 -->
        <div class="download-box" v-show="isShow">
            <img class="logo" :src="logo" alt="">
            <div class="text-box">
                <p class="t1">{{this.project}}</p>
                <p class="t2">{{$t('download.t1')}}</p>
            </div>
            <a class="btn" @click="link">{{$t('download.xz')}}</a>
            <img class="btn-close" @click="downLoadClose" src="@/assets/close.png" alt="">
        </div>
        <!-- 公告弹窗 -->
        <div class="mask-notice" v-show="isNotice">
            <div class="notice-wrap">
                <div class="title">{{$t('news.gg')}}</div>
                <div class="cont" v-html="noticeHtml"></div>
                <div class="notice-btn btn-bg" @click="goDetail">{{$t('news.ckxq')}}</div>
                <img class="btn-close" @click="noticeClose" src="@/assets/Log-In_delete.png" alt="">
            </div>
        </div>
        <nav-bar :navName="'index'"></nav-bar>
        <loading v-show="isLoad"></loading>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
import loading from '@/components/loading.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
let that = this;
let vm = null;
export default {
    name: 'index',
    data () {
        return {
            theme: false,
            logo: '',
            isShow: false,
            token: '',
            swiper: null,
            websock: null,
            bannerList: [],
            noticeList: [],
            listData: [],
            currencyList: [],
            isNotice: false,
            noticeId: '',
            noticeHtml: '',
            isDownLoad: '',
            isNoticeShow: '',
            isLoad: false,
            service_link: '',
            swiperOption: {
                notNextTick: true,
                loop:true,
                autoplay:{
    　　　　　　　　delay: 4000,
    　　　　　　　　stopOnLastSlide: false,
    　　　　　　　　/* 触摸滑动后是否继续轮播 */
    　　　　　　　　disableOnInteraction: false
    　　　　　　},
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true,
                },
                on:{
                    click: ()=>{
                        let swiper1 = this.$refs.mySwiper.$swiper;
                        let i = swiper1.realIndex;
                        vm.bannerLink(i);
                    }
                }
            },
            swiperOption2: {
                notNextTick: true,
                loop: true,
                direction: "vertical",
                autoplay:{
    　　　　　　　　delay: 4000,    　　　　　　　　
　　　　　　     },
                on:{
                    click: ()=>{
                        let swiper = this.$refs.mySwipers.$swiper;
                        let i = swiper.realIndex;
                        vm.goNotice(i);
                    }
                },
            },
            lang: 'en',
            type: 2
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        vm = this;
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      this.isDownLoad = sessionStorage.getItem('isDownLoad') || window.GLOBAL.isDownLoad;
		  this.isNoticeShow = sessionStorage.getItem('isNoticeShow');
      if(this.isDownLoad){
        this.isShow = false;
      }else{
        this.isShow = true;
      }
      this.getBanner();
      this.getGG();
      this.getmarketList();
      this.initWebSocket();
      this.getLogo();
      this.getParams();
    },
    methods: {
      tab(id){
        this.type = id;
        this.listData = [];
        this.currencyList = [];
        this.getmarketList();
      },
      service(){
        if(!this.service_link) return;
        this.$router.push({ path: '/service', query: { url: this.service_link } })
      },
      getParams(){
          this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
              let resData = res.data.data;
              this.service_link = resData.filter((item) =>{
                  if(item.key == 'online_service'){
                      return item
                  }
              })[0].value;
          }).catch(function(err){
              console.log(err)
          })
       },
        getTempLogin(){
		  	  let params = {
              token:1,
          }
          this.$ajax.get('/web/tempLogin',{params}).then((res) => {
              console.log(res)
          }).catch(function(err){
              console.log(err)
          })
        },
      goDetail(){
          this.$router.push({path: "/notice",query: { id: this.noticeId }});
      },
      goNotice(idx){
          let id = this.noticeList[idx].id;
          this.$router.push({path: "/notice",query: { id: id }});
      },
      bannerLink(i){
          let id = this.bannerList[i].id;
          let content = this.bannerList[i].content;
          if(id){
              if(this.filterHtmlTag(content)){
                  this.$router.push({path: "/bannerDetail",query: { id }});
              }
          }
      },
      noticeClose(){
        if(this.isNoticeShow != null){
        this.isNotice = true;
        sessionStorage.removeItem('isNoticeShow');
			}else{
				this.isNotice = false;
				sessionStorage.setItem('isNoticeShow',true);
			}
       },
       downLoadClose(){
           if(this.isDownLoad){
				this.isShow = true;
				sessionStorage.removeItem('isDownLoad');
			}else{
				this.isShow = false;
				sessionStorage.setItem('isDownLoad',true);
			}
       },
       link(){
           this.$router.push('/downLoad')
       },
       jump(symbol){
         if(this.type == 1){
           this.$router.push({ path: '/contractTransaction', query: { symbol: symbol } })
         }else{
           this.$router.push({ path: '/preciousMetal', query: { symbol: symbol } })
         }
        },
       getBanner(){
		  	let params = {
                token:1,
            }
            this.$ajax.get('/web/getBanner',{params}).then((res) => {
                let resData = res.data.data;
                this.bannerList = resData;

            }).catch(function(err){
                console.log(err)
            })
        },
      getGG(id){
            this.$ajax.get('/web/getGG').then((res) => {
              if(res.data.code != 1000){
                var noticeArr = [];
                let resData = res.data.data;
                this.noticeList = resData;
                if(resData.length > 0){
                  noticeArr = resData.filter((item,index) =>{
                  if(item.is_popover == 1){
                    return true;
                  }else{
                    return ''
                  }
                });
                if(noticeArr.length > 0){
                  if(this.isNoticeShow){
                    this.isNotice = false;
                  }else{
                    this.isNotice = true;
                  }
                  this.noticeId = noticeArr[0].id;
                  this.getNotice(this.noticeId);
                }
                }else{
                    this.isNotice = false
                }
              }else{
                this.isNotice = false
              }

          }).catch(function(err){
              console.log(err)
          })
		  },
      getNotice(id){
			  let params = {
              id:id,
            }
            this.$ajax.get('/web/getText',{params}).then((res) => {
                let resData = res.data.data;
                this.noticeHtml = this.contHtml(resData.content);
            }).catch(function(err){
                console.log(err)
            })
	  	},
      getLogo(){
			  let params = {
            key: 'app_logo',
            token:1,
        }
        this.$ajax.get('/web/getLogo',{params}).then((res) => {
          let resData = res.data.data;
          this.logo = resData;
        }).catch(function(err){
            console.log(err)
        })
	  	},
       getmarketList() {
        var that = this;
        let params = {
            type: this.type,
            token: '',
            id: 1,
            classify: 0
        }
        that.isLoad = true;
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          var curr;
          that.listData = resData;
          that.currencyList = [];
          for (curr in that.listData){
            that.currencyList[that.listData[curr].currency] = [that.listData[curr].icon,that.listData[curr].symbol];
          }
          that.isLoad = false;
        }).catch(function(err){
            console.log(err)
        })
        },
       initWebSocket(){ //初始化weosocket
            const wsuri = this.socket_url;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //连接建立之后执行send方法发送数据
        },
        websocketonerror(){//连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e){ //数据接收
          let msg = JSON.parse(e.data).content;
          if(JSON.parse(e.data).action == "marketprice"){
            let keyArr = [];
            for(var x in this.currencyList){
              for(var y in this.listData){
                x = this.type == 1 ? x.toLowerCase() : x;
                if(!msg[x]) return;
                if(msg[x].symbol == this.listData[y].symbol){
                  this.listData[y]['new_price'] = msg[x].now_price;
                  this.listData[y]['grow'] = msg[x].change;
                  keyArr.push(this.listData[y]);
                  break;
                }
              }
            }
            this.listData = keyArr;
          }
        },
        websocketsend(Data){//数据发送
            this.websock.send(Data);
        },
        websocketclose(e){  //关闭
            // console.log('断开连接',e);
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");
            str = str.replace(/&#039;/g, "'");
            return str;
        },
        filterHtmlTag(msg){
            var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
                msg = msg.replace(/[|]*\n/, '') //去除行尾空格
                msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
                return msg;
        },
    },
    components:{
        navBar,
        Swiper,
        SwiperSlide,
        loading
    },
    beforeDestroy(){
      this.websock.close(); //离开路由之后断开websocket连接
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        background: #fff;
        box-sizing: border-box;
    }
    .head .icon{
        width: .9rem;
        height: .94rem;
    }
    .head .text{
      position: absolute;
      top: 50%;
      left: .4rem;
      font-size: .42rem;
      transform: translateY(-50%);
    }
    .head .title{
        font-size: .56rem;
    }
    .head .lang{
        position: absolute;
        top: 50%;
        right: .4rem;
        font-size: .42rem;
        transform: translateY(-50%);
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 2.1rem;
        width: 100%;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .banner-wrap{
      height: 3.92rem;
      margin: 0 .44rem;
    }
    .cotainer .banner-wrap .banner-box{
      height: 100%;
    }
    .cotainer .banner-box .img{
        width: 100%;
        height: 3.92rem;
        border-radius: .2rem;
    }
    .cotainer .notice-box{
        display: flex;
        align-items: center;
        height: 1rem;
        padding: 0 .44rem;
        overflow: hidden;
    }
    .cotainer .notice-box .icon{
        width: .6rem;
    }
    .cotainer .notice-box .notice{
        flex: 1;
        height: 1rem;
        padding: 0 .4rem;
        line-height: 1rem;
        overflow: hidden;
    }
    .cotainer .notice-box .notice .swiper-container{
        height: 1rem;
    }
    .cotainer .notice-box .notice .text{
        color: #000;
        font-size: .4rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .cotainer .notice-box .arrow{
      width: .3rem;
    }
    .cotainer .coin-box{
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        margin: .3rem .32rem 0;
        overflow-x: scroll;
    }
    .cotainer .coin-box .coin-li{
        padding: .2rem .3rem .16rem;
        text-align: center;
    }
    .cotainer .coin-box .coin-head{
        display: flex;
        align-items: center;
    }
    .cotainer .coin-box .coin-head .icon{
        width: .59rem;
        height: .59rem;
    }
    .cotainer .coin-box .coin-head .text{
        color: #000;
        font-size: .35rem;
        padding-left: .2rem;
    }
    .cotainer .coin-box .coin-head .text .t1{
        color: #b0b0b0;
    }
    .cotainer .coin-box .price{
        padding: .3rem 0 .2rem;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .coin-box .change{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #49d674;
    }
    .cotainer .coin-box .change .arrow{
        height: .8rem;
        margin-right: .1rem;
    }
     .cotainer .coin-box .change .arrow.die{
         transform: rotate(180deg);
     }
    .cotainer .line{
        width: 100%;
        height: .18rem;
        background: #f9f9f9;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-around;
        align-items: stretch;
        flex-flow: wrap;
    }
    .cotainer .item-box .item{
        width: 25%;
        padding: .4rem 0;
        text-align: center;
    }
    .cotainer .item-box .item .icon{
        /* width: .72rem; */
        height: .8rem;
    }
    .cotainer .item-box .item .text{
        padding-top: .3rem;
        color: #000;
        font-size: .34rem;
    }
    .cotainer .table-head{
        display: flex;
        align-items: center;
        padding: .4rem .32rem 0;
    }
    .cotainer .table-head .th{
        width: 33.33%;
        color: #7f7f7f;
        font-size: .35rem;
    }
    .cotainer .table-body{
        padding: 0 .4rem;
    }
    .cotainer .table-body .tr{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .4rem 0;
        border-bottom: 1px solid #eee;
    }
    .cotainer .table-body .tr .item{
        width: 33.33%;
    }
    .cotainer .table-body .coin{
        display: flex;
        align-items: center;
    }
    .cotainer .table-body .coin .icon{
        width: .94rem;
        height: .94rem;
        margin-right: .3rem;
    }
    .cotainer .table-body .coin .t1{
        color: #000;
        font-size: .38rem;
    }
    .cotainer .table-body .coin .t2{
        color: #b0b0b0;
        font-size: .32rem;
    }
    .cotainer .table-body .price{
        color: #000;
        font-size: .48rem;
    }
    .cotainer .table-body .change .persent{
        display: inline-block;
        width: 2rem;
        padding: 6px;
        color: #fff;
        border-radius: 4px;
        background: #00c483;
        text-align: center;
    }
    /* 公告弹窗 */
    .notice-wrap{
        position: fixed;
        left: 5%;
        right: 5%;
        top: 50%;
        z-index: 12;
        width: 90%;
        padding: 0 6px;
        border-radius: 4px;
        background: #fff;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .notice-wrap .title{
        padding: 10px;
        color: #000;
        font-size: 15px;
        text-align: center;
    }
    .notice-wrap .cont{
        min-height: 80px;
        max-height: 200px;
        padding: 10px;
        color: #666;
        font-size: 12px;
        word-break: break-word;
        overflow-y: auto;
    }
    .notice-wrap .notice-btn{
        height: 36px;
        margin: 10px 10px 20px;
        line-height: 36px
    }
    .notice-wrap .btn-close{
        position: absolute;
        right: 10px;
        top: 10px;
        width: 20px;
    }
    /* .notice-wrap .cont img{
      position: relative;
      max-width: 100%;
      left: 50%;
      transform: translateX(-50%);
    } */
    /* 下载框 */
    .download-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        left: 2%;
        bottom:2.1rem;
        width: 96%;
        height: 60px;
        padding: 0 5px;
        border-radius: 4px;
        background: #3381d5;
        box-sizing: border-box;
    }
    .download-box .logo{
        height: 25px;
    }
    .download-box .text-box .t1{
        font-size: 13px;
        margin-bottom: 4px;
    }
    .download-box .text-box{
        flex: 1;
        margin: 0 5px;
        color: #fff;
        font-size: 12px;
    }
    .download-box .btn{
        margin-right: 15px;
        padding: 5px 10px;
        color: #000;
        font-size: 12px;
        border-radius: 4px;
        background: #fff;
        text-align: center;
    }
    .download-box .btn-close{
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 999;
        width: 12px;
        height: 12px;
    }
    .tab-box{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: .42rem 0;
    }
    .tab-box .tab{
      position: relative;
      padding: 0 .5rem;
      color: #150700;
      font-size: .52rem;
    }
    .tab-box .tab.active::after{
      position: absolute;
      left: 50%;
      bottom: -.2rem;
      content: '';
      width: .78rem;
      height: .06rem;
      background: #2d66cf;
	    border-radius: 0.03rem;
      transform: translateX(-50%);
    }
</style>
<style>
  .notice-wrap .cont img{
    position: relative;
    max-width: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue